"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultRowMobile = exports.ResultRowDesktop = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _decorators = require("../../decorators");
var _searchResultUtils = require("../../utils/search-result-utils");
var _Text = require("../Text");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } //lodash
//helpers
//components
//styled-components
var origin = window.location.origin;
var ResultRowBase = (0, _decorators.styleable)(function (_ref) {
  var _ref$result = _ref.result,
    guideTitle = _ref$result.guideTitle,
    id = _ref$result.id,
    index = _ref$result.index,
    instructionTitle = _ref$result.instructionTitle,
    locale = _ref$result.locale,
    media = _ref$result.media,
    stepCount = _ref$result.stepCount,
    title = _ref$result.title,
    topicTitle = _ref$result.topicTitle,
    totalPublishedInstructionsNumber = _ref$result.totalPublishedInstructionsNumber,
    device = _ref.device,
    _ref$shouldShowShadow = _ref.shouldShowShadowOnHover,
    shouldShowShadowOnHover = _ref$shouldShowShadow === void 0 ? false : _ref$shouldShowShadow,
    _ref$shouldShowSpinne = _ref.shouldShowSpinnerWhileLoading,
    shouldShowSpinnerWhileLoading = _ref$shouldShowSpinne === void 0 ? false : _ref$shouldShowSpinne;
  var isMobile = device === 'mobile';
  var Heading = isMobile ? _styles.StyledHeadingMobile : _styles.StyledHeadingDesktop;
  var Text = isMobile ? _Text.TextMobile : _Text.TextDesktop;
  var imageUrl = (0, _get["default"])(media, 'mediaResource.url');
  var metadata = (0, _get["default"])(media, 'metadata');
  var extraInformation, subtitle;

  // extract title
  if (index === 'steps') {
    extraInformation = topicTitle ? " < ".concat(instructionTitle, " < ").concat(topicTitle, " < ").concat(guideTitle) : " < ".concat(instructionTitle, " < ").concat(guideTitle);
  } else if (index === 'instructions') {
    extraInformation = topicTitle ? " < ".concat(topicTitle, " < ").concat(guideTitle) : " < ".concat(guideTitle);
    subtitle = "".concat(stepCount, " steps");
  } else {
    subtitle = "".concat(totalPublishedInstructionsNumber, " instructions");
  }
  return /*#__PURE__*/_react["default"].createElement(_styles.ResultRow, {
    "data-testid": "anchor",
    href: "".concat(origin, "/ql/").concat(index, "/").concat(id, "?locale=").concat(locale),
    device: device,
    shouldShowShadowOnHover: shouldShowShadowOnHover
  }, /*#__PURE__*/_react["default"].createElement(_styles.StyledCloudinaryPicture, {
    metadata: metadata,
    shouldShowSpinnerWhileLoading: shouldShowSpinnerWhileLoading,
    src: imageUrl
  }), /*#__PURE__*/_react["default"].createElement(_styles.ContentWrapper, null, /*#__PURE__*/_react["default"].createElement(Heading, {
    maxlines: 1,
    size: "xsmall",
    "data-testid": "title"
  }, /*#__PURE__*/_react["default"].createElement("b", null, title), extraInformation), /*#__PURE__*/_react["default"].createElement(Text, {
    secondary: true,
    "data-testid": "subtitle"
  }, subtitle)), isMobile && /*#__PURE__*/_react["default"].createElement(_styles.Chevron, null));
});
ResultRowBase.propTypes = {
  device: _propTypes["default"].oneOf(['desktop', 'mobile']).isRequired,
  result: _searchResultUtils.NormalizedSearchResultPropType.isRequired,
  shouldShowShadowOnHover: _propTypes["default"].bool,
  shouldShowSpinnerWhileLoading: _propTypes["default"].bool
};
var ResultRowDesktop = exports.ResultRowDesktop = function ResultRowDesktop(props) {
  return /*#__PURE__*/_react["default"].createElement(ResultRowBase, _extends({
    device: "desktop"
  }, props));
};
var ResultRowMobile = exports.ResultRowMobile = function ResultRowMobile(props) {
  return /*#__PURE__*/_react["default"].createElement(ResultRowBase, _extends({
    device: "mobile"
  }, props));
};
//# sourceMappingURL=index.js.map